import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';

import { EnvironmentService } from '@app/core/environment-service';

import { localizedUrlTree } from './localized-url-tree.util';

/** Blocks the sportsbook route on surfaces where betting is disabled (cases, cases-modes, fastcs2), redirecting to the localized root. */
export const bettingSurfaceGuard: CanActivateFn = () => {
  const environmentService = inject(EnvironmentService);

  return environmentService.isBettingSurfaceEnabled ? true : localizedUrlTree('/');
};
